import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import "./SidebarAccordion.css";

const SidebarAccordion = ({ title, links, currentPath }) => (
  <Accordion className="accordion" disableGutters>
    <AccordionSummary
      expandIcon={<span className="material-icons">keyboard_arrow_down</span>}
      className="accordion-summary"
    >
      <Typography className="sidebar-section">{title}</Typography>
    </AccordionSummary>
    <AccordionDetails className="accordion-details">
      <ul className="sidebar-submenu">
        {links.map(({ label, path, icon: Icon, iconSelected: IconSelected }) => {
          const isSelected = currentPath === path;
          const MenuIcon = isSelected ? IconSelected || Icon : Icon;
          return (
            <li key={path} className={isSelected ? "selected" : ""}>
              <Link to={path}>
                {MenuIcon && <MenuIcon className="menu-icon" />}
                <span>{label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </AccordionDetails>
  </Accordion>
);

export default SidebarAccordion;
